import { EiacFileType } from "../containers/clients/clients-dashboard/clients-dashboard-types";

export const TABPARAMNAME = {
  SIMULACIONES: "simulaciones" as "simulaciones",
  SOLICITUDES: "solicitudes" as "solicitudes",
  CARTERAS: "carteras" as "carteras",
  RENOVACIONES: "renovaciones" as "renovaciones",
  FICHEROS_EIAC: "ficheros-eiac" as "ficheros-eiac",
  IMPAGADOS: "impagados" as "impagados",
};

interface EiacFileOption {
  value: EiacFileType;
  label: string,
}

export const EIAC_FILES_TYPES: EiacFileOption[] = [
  { value: "all", label: "Todos" },
  { value: "policies", label: "Pólizas" },
  { value: "receips", label: "Recibos" },
];
